// AUF Dark — design tokens
// Single source of truth for all colors, spacing, and reusable style objects.

export const T = {
  // ── Backgrounds ────────────────────────────────────────────────
  bg:          'var(--c-bg)',
  sidebar:     'var(--c-sidebar)',
  card:        'var(--c-card)',
  cardHover:   'var(--c-card-hover)',
  input:       'var(--c-input)',

  // ── Borders ────────────────────────────────────────────────────
  border:      'var(--c-border)',
  borderLight: 'var(--c-border-light)',

  // ── Text ───────────────────────────────────────────────────────
  text:        'var(--c-text)',
  textSub:     'var(--c-text-sub)',
  textMuted:   'var(--c-text-muted)',
  textDim:     'var(--c-text-dim)',

  // ── Accent (AUF Yellow) ────────────────────────────────────────
  accentOn:     'var(--c-accent-on)',
  accent:       'var(--c-accent)',
  accentHover:  'var(--c-accent-hover)',
  accentDim:    'var(--c-accent-dim)',
  accentBorder: 'var(--c-accent-border)',

  // ── Главное действие ───────────────────────────────────────────
  // Меняет РОЛЬ между темами: светлая — графит, тёмная — жёлтый.
  // На кнопках использовать btn/btnText, а не accent.
  btn:      'var(--c-btn)',
  btnText:  'var(--c-btn-text)',

  // ── Серии графиков (фиксированный порядок) ─────────────────────
  // Полный набор со стилями осей — в shared/chartTheme.js.
  s1: 'var(--c-s1)',
  s2: 'var(--c-s2)',
  s3: 'var(--c-s3)',
  s4: 'var(--c-s4)',
  s5: 'var(--c-s5)',

  // ── Status colors ──────────────────────────────────────────────
  danger:     'var(--c-danger)',
  dangerDim:  'var(--c-danger-dim)',
  success:    'var(--c-success)',
  successDim: 'var(--c-success-dim)',
  warning:    'var(--c-warning)',
  warningDim: 'var(--c-warning-dim)',
  info:       'var(--c-info)',
  infoDim:    'var(--c-info-dim)',

  // ── Radii ──────────────────────────────────────────────────────
  shadowSm: 'var(--c-shadow-sm)',
  shadowMd: 'var(--c-shadow-md)',

  // card/item/pill — Soft Slate. xs..xl — legacy, постепенно уходят.
  r:  { xs: 4, sm: 6, md: 10, lg: 14, xl: 20, card: 16, item: 10, pill: 99 },

  // ── Layout ─────────────────────────────────────────────────────
  sidebarW:          220,
  sidebarCollapsedW: 60,
};

// ── Reusable inline style objects ──────────────────────────────────

/** Primary (yellow) button */
export const btnPrimary = {
  padding: '8px 16px',
  borderRadius: T.r.pill,
  border: 'none',
  background: T.btn,
  color: T.btnText,
  cursor: 'pointer',
  fontWeight: 700,
  fontSize: 15,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  whiteSpace: 'nowrap',
};

/** Ghost button */
export const btnGhost = {
  padding: '8px 16px',
  borderRadius: T.r.pill,
  border: `1px solid ${T.borderLight}`,
  background: 'transparent',
  color: T.textSub,
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: 15,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  whiteSpace: 'nowrap',
};

/** Danger ghost button */
export const btnDanger = {
  ...btnGhost,
  borderColor: T.dangerDim,
  color: T.danger,
};

/** Standard card */
export const card = {
  background: T.card,
  border: 'none',
  borderRadius: T.r.card,
  boxShadow: T.shadowSm,
};

/** Section header inside a page body */
export const sectionTitle = {
  fontSize: 16,
  fontWeight: 700,
  color: T.text,
};

/** Small muted label */
export const fieldLabel = {
  fontSize: 14,
  fontWeight: 600,
  color: T.textMuted,
  marginBottom: 4,
};

/** Standard text input */
export const inputStyle = {
  width: '100%',
  padding: '8px 12px',
  borderRadius: T.r.pill,
  border: `1px solid ${T.border}`,
  background: T.input,
  color: T.text,
  fontSize: 15,
  outline: 'none',
};

/** Badge variants */
export const badge = {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '3px 9px',
    borderRadius: T.r.pill,
    fontSize: 13,
    fontWeight: 700,
    whiteSpace: 'nowrap',
  },
  success: { background: T.successDim, color: T.success },
  danger:  { background: T.dangerDim,  color: T.danger  },
  warning: { background: T.warningDim, color: T.warning },
  accent:  { background: T.accentDim,  color: T.accent  },
  info:    { background: T.infoDim,    color: T.info    },
  neutral: { background: T.cardHover,  color: T.textSub },
};
